import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=572ead6d&scoped=true&"
import script from "./Notes.vue?vue&type=script&lang=ts&"
export * from "./Notes.vue?vue&type=script&lang=ts&"
import style0 from "./Notes.vue?vue&type=style&index=0&id=572ead6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572ead6d",
  null
  
)

export default component.exports